import { Base } from "./base";
import { Polygon } from "./polygon";

export class AreaDespacho extends Base {
  public descricao!: string;
  public polygon?: Polygon;
  public participa?: boolean;
}
